/**
 * L-NAV-9 — COMPATIBILITÉ DESCENDANTE DES NOUVEAUX DRAPEAUX D'ÉCRAN (jumelle
 * frontend de `apps/backend/src/auth/guards/permissions.guard.ts`, une spec de
 * parité les compare : `access/legacyFallbacks.spec.ts`).
 *
 * `canAccessSmsLogs`, `canAccessEmailLogs`, `canAccessSmsTemplates` et
 * `canAccessEmailTemplates` valent `false` pour tout le monde en prod (relevé
 * 2026-10-16) ; les écrans qu'ils gouvernent désormais s'ouvraient aux ADMIN
 * par `canManagePermissions`. Un drapeau neuf est donc ACQUIS si l'ancienne
 * condition est vraie — personne ne perd rien au premier déploiement.
 *
 * Bascule (docs/architecture/SQL-NAV-9.md) : UPDATE qui copie
 * `canManagePermissions` dans les 4 colonnes, puis vider cette table et sa
 * jumelle backend dans le même déploiement.
 */
import type { PermissionKey } from '../types/permissions'

export const LEGACY_PERMISSION_FALLBACKS: Readonly<Partial<Record<PermissionKey, readonly PermissionKey[]>>> = {
  canAccessSmsLogs: ['canManagePermissions'],
  canAccessEmailLogs: ['canManagePermissions'],
  canAccessSmsTemplates: ['canManagePermissions'],
  canAccessEmailTemplates: ['canManagePermissions'],
}

/**
 * Enveloppe un lecteur de drapeaux BRUTS pour qu'il rende aussi les drapeaux
 * acquis par une ancienne condition. `fallbacks` n'est paramétrable que pour
 * les tests (état « bascule faite »).
 */
export function withLegacyFallbacks(
  hasRaw: (permission: PermissionKey) => boolean,
  fallbacks: Readonly<Partial<Record<PermissionKey, readonly PermissionKey[]>>> = LEGACY_PERMISSION_FALLBACKS,
): (permission: PermissionKey) => boolean {
  return (permission) => hasRaw(permission) || (fallbacks[permission] ?? []).some((legacy) => hasRaw(legacy))
}
